// extracted by mini-css-extract-plugin
module.exports = {"dataTableUpdate":"DataTableUpdate_dataTableUpdate__37Y-S"};